import { clientController } from "../../../../../../cdm/controllers/client-controller";
import { transportationSetup } from "./setup";
import { stateController } from "../../../../../../cdm/controllers/state-controller";

export const transportationGroup = isFirstTime => ({
  preSetup: clientController.getUserGroupsAndMembers,
  rootBack: {
    icon: isFirstTime ? "exit-to-app" : null,
    onPress: isFirstTime
      ? () => clientController.execLogout(true, true)
      : // ? props => {
        //     stateController.viewGroupId = -1;
        //     props.navigation.navigate("Root");
        //   }
        props => {
          stateController.initSetupMode = "addGroup";
          props.resetSetup();
        }
  },
  skipSelect: true,
  initialTitle: "Transportation Service Profile Setup",
  initialHeading: `${
    clientController.defaultMember.profile.data.displayName
  }, let's setup your Transportation Service profile.`,
  finishTitle: "Setup Complete",
  setupList: [
    {
      ...transportationSetup()
    }
  ],
  onFinishSetup: props => {
    isFirstTime
      ? props.navigation.navigate("Root")
      : (() => {
          const groups = clientController.findVisibleGroups();
          if (groups.length > 0)
            stateController.viewGroupId = groups.sort(
              (a, b) => b.id - a.id
            )[0].id;
          props.navigation.navigate("Group");
        })();
  },
  finishHeading: isFirstTime && "Thank you for completing the initial setup."
});
